import React from "react";
import SearchResults from "../../lib/Pages/SearchResults";

function SearchPage() {
  return <SearchResults />;
}

export default SearchPage
